'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _headerState = require('../components/headerState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  bindUIActions();
};

var bindUIActions = function bindUIActions() {
  $(_dom2.default.siteSearch).on('keyup', function () {
    if ($(this).val() !== '') {
      (0, _headerState.headerState)('active');
      $(this).addClass('has-content');
    } else {
      (0, _headerState.headerState)('inactive');
      $(this).removeClass('has-content');
    }
  });
};